module.exports = __webpack_public_path__ + "static/img/fa3.c9179f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newWebSiteImg/pc/solution/fa3.png
// module id = prLB
// module chunks = 3